import React from 'react';
import ContentLoader from 'react-content-loader';
import PanelContainer from './../PanelContainer';
import MediaQuery from 'react-responsive';

const JobContentLoader = props => (
  <>
    <MediaQuery query="(min-width: 768px)">
      <PanelContainer
        styles={{
          height: '600px',
        }}
      >
        <ContentLoader
          height={570}
          width={825}
          speed={2}
          primaryColor="#f3f3f3"
          secondaryColor="#ecebeb"
        >
          <rect x="0" y="5" rx="0" ry="0" width="225" height="28" />
          <rect x="663" y="9" rx="0" ry="0" width="135" height="22" />
          <rect x="0" y="72" rx="0" ry="0" width="155" height="17" />
          <rect x="0" y="104" rx="0" ry="0" width="155" height="17" />
          <rect x="0" y="151" rx="0" ry="0" width="803" height="2" />
          <rect x="0" y="182" rx="0" ry="0" width="223" height="17" />
          <rect x="0" y="218" rx="0" ry="0" width="132" height="17" />
          <rect x="0" y="268" rx="0" ry="0" width="223" height="17" />
          <rect x="0" y="303" rx="0" ry="0" width="177" height="17" />
          <rect x="0" y="353" rx="0" ry="0" width="223" height="17" />
          <rect x="0" y="386" rx="0" ry="0" width="71" height="17" />
          <rect x="0" y="438" rx="0" ry="0" width="165" height="54" />
          <rect x="204" y="456" rx="0" ry="0" width="71" height="17" />
        </ContentLoader>
      </PanelContainer>
    </MediaQuery>
  </>
);

export default JobContentLoader;
